import { Card } from '@/components/ui/card';
import { Theme } from '@repo/types/src/glow-up';
import { DeleteTheme } from './DeleteTheme';
import { EditTheme } from './EditTheme';

type ThemeCardProps = {
  theme: Theme;
  refetch: () => void;
};

export const ThemeCard = ({ theme, refetch }: ThemeCardProps) => {
  return (
    <Card className="p-4 w-80 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <h3 className="font-semibold text-lg">{theme.title}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">
          {theme.description}
        </p>
      </div>

      <div className="flex gap-2 mt-auto">
        <EditTheme theme={theme} refetch={refetch} />
        <DeleteTheme theme={theme} refetch={refetch} />
      </div>
    </Card>
  );
};
